import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

export const Buttons = styled.div<{
  numberOfButtons: number;
  showStackedLayout?: boolean;
}>`
  display: grid;
  ${({ showStackedLayout }) =>
    !showStackedLayout && `grid-template-columns: 1fr;`}
  grid-gap: 12px;

  margin-top: auto;

  ${QUERIES.laptopAndUp} {
    ${({ showStackedLayout, numberOfButtons }) =>
      !showStackedLayout &&
      `grid-template-columns: repeat(${numberOfButtons}, 1fr);`}
    grid-gap: 24px;
  }
`;
